import Dislike from './Dislike';

export default Dislike;